import { Loading } from "components/panels";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import { WarningPill } from "components/Pill/WarningPill";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import React from "react";

interface Props {
  contactSmall: server.dto.ContactSmallV2;
  contactName: server.dto.PersonName;
}

export const ContactForExtractorSessionList = (props: Props) => {
  const { contactSmall, contactName } = props;
  const [isSaving, setIsSaving] = React.useState(false);
  const [isContactPickerOpen, setIsContactPickerOpen] = React.useState(false);

  if (isSaving) {
    return <Loading />
  }

  if (contactSmall) {
    return <ContactSidePanel
      contactId={contactSmall.contactId}
      trigger={<a>{contactSmall.name.fullName}</a>}
    />
  }

  const onContactSelected = async (contact: server.dto.ContactSmallV2) => {
    setIsSaving(true);
    await window.CoreApi.ContactAlias.Create({
      contactId: contact.contactId,
      name: {
        first: contactName.firstName,
        insertion: contactName.insertion,
        last: contactName.lastName,
      }
    });
    setIsSaving(false);
  }

  return <div>
    <div><WarningPill onClick={() => setIsContactPickerOpen(true)} label={contactName.fullName} /></div>
    <span>Could not match contact</span>
    {isContactPickerOpen && <ContactModalPicker
      initialKeyword={contactName.lastName}
      buttonLabel=""
      onModalClose={() => setIsContactPickerOpen(false)}
      canCreateNew={false}
      nonInPageEditing={{
        onChange: onContactSelected,
        startOpen: true,
        value: undefined,
        required: false,
        validatorKey: "contactModalPicker",
      }}
    />}
  </div>
}